// SSP broadcasts turbo_power's stream actions (set_attribute, add_css_class)
import { Turbo } from '@hotwired/turbo-rails'
import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)

// SSP-specific Stimulus controllers; the generic ones are registered by platform_ui
import LiveInputFieldController from '../view_components/live_input_field/live_input_field'
window.Stimulus.register('live-input', LiveInputFieldController)

import LiveStringInputFieldController from '../view_components/live_string_input_field/live_string_input_field'
window.Stimulus.register('live-string-input', LiveStringInputFieldController)

import DirtyFilterFormController from './controllers/dirty_filter_form_controller'
window.Stimulus.register('dirty-filter-form', DirtyFilterFormController)

// TableComponent: row selection, page size and record iteration
import CheckboxSelectAll from 'stimulus-checkbox-select-all'
window.Stimulus.register('checkbox-select-all', CheckboxSelectAll)

import TurboCheckboxController from './controllers/turbo_checkbox_controller'
window.Stimulus.register('turbo-checkbox', TurboCheckboxController)

import PageSizeSelectController from './controllers/page_size_select_controller'
window.Stimulus.register('page-size-select', PageSizeSelectController)

import RecordIteratorController from '../view_components/record_iterator_control/record_iterator_control'
window.Stimulus.register('record-iterator', RecordIteratorController)
